import http from "../jslibs/axios/http";

// 获取演示/商务列表
export const getFormRecord = (data) => http.get("/v1/cms/FormRecord", data);

// 编辑获取演示/商务
export const editFormRecord = (uuid, data) => http.put(`/v1/cms/FormRecord/${uuid}`, data);

// 删除演示/商务
export const deleteFormRecord = (uuid) => http.delete(`/v1/cms/FormRecord/${uuid}`);

// 导出excel
export const formRecordExcel = (data) => http.get("/v1/cms/FormRecordExcel", data);

// 高端定制列表
export const customization = (data) => http.get("/v1/cms/Customization", data);
// 导出
export const customizationExcel = (data) => http.get("/v1/cms/CustomizationExcel", data);
// 备注
export const editCustomization = (uuid, data) => http.put(`/v1/cms/Customization/${uuid}`, data);
// 删除
export const deleteCustomization = (uuid) => http.delete(`/v1/cms/Customization/${uuid}`);

// 白皮书下载
export const whitePaper = (data) => http.get("/v1/cms/WhitePaper", data);
// 导出
export const whitePaperExcel = (data) => http.get("/v1/cms/WhitePaperExcel", data);
// 备注
export const editWhitePaper = (uuid, data) => http.put(`/v1/cms/WhitePaper/${uuid}`, data);
// 删除
export const deleteWhitePaper = (uuid) => http.delete(`/v1/cms/WhitePaper/${uuid}`);
